/* src/app/system-view/menu-list-item/menu-list-item.component.scss */
:host {
  display: flex;
  flex-direction: column;
  outline: none;
  width: 100%;
}
.mat-mdc-list-item {
  padding: 0px 0;
  width: auto;
}
.mat-mdc-list-item .routeIcon {
  margin-right: 30px;
  display: flex;
  flex-direction: column;
}
.mat-mdc-list-item .routeIconSvg {
  margin-right: 30px;
  transform: scale(1.5);
  display: flex;
  flex-direction: column;
}
.menu-list-item-detail {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 12px;
}
/*# sourceMappingURL=menu-list-item.component.css.map */
